module.exports = __webpack_public_path__ + "static/img/banner_product.d75866f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_product.jpg
// module id = knvq
// module chunks = 1